import { IconButton, InputAdornment, TextField, } from '@mui/material'
import { forwardRef } from 'react';

interface TextinputProps {
  name: string,
  value?: string
  label?: string,
  placeholder?: string,
  type?: "text" | "number" | "email" | "date" | "password",
  InputPropIcon?: any,
  disabled?: boolean,
  error?: boolean,
  helpText?: string,
  register?:any,
  InputPropOnClick?: () => void
}

function TextInput ({ value, name, label, type = "text", placeholder, disabled = false, InputPropIcon, InputPropOnClick, error, helpText , register, ...props }: TextinputProps, ref: any) {
  return (
      <TextField
        ref={ref}
        defaultValue={value}
        fullWidth
        name={name}
        label={label}
        placeholder={placeholder}
        type={type}
        disabled={disabled}
        helperText={helpText}
        error={error}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={InputPropOnClick}>
                {InputPropIcon}
              </IconButton>
            </InputAdornment>
          )
        }}
        {...props} 
      />
  )
}

export default forwardRef(TextInput)